module.exports = __webpack_public_path__ + "static/media/bh.d525aaa2.svg";